import { Region } from './types';

export const useRegions = () => {
  const regionsOptions = Object.entries(Region).map(key => ({ label: key[1], value: key[0] }));
  const regions = regionsOptions.map(region => region.value);

  return { regions, regionsOptions };
};
